import {lazy} from '@aboutyou/lazy-imports';

export const CardsSliderAmbient = lazy(() =>
  import('./CardsSliderAmbient.eager').then(mod => ({
    default: mod.CardsSliderAmbient,
  })),
);
